"use client";
import useAxiosPublicInstance from "@/hooks/useAxiosPublicInstance";
import Description from "@/partials/elements/Description";
import Logo from "@/partials/sections/Navbar/components/NavbarLg/components/Logo";
import FlexSection from "@/partials/sections/Section/FlexSection";


import React from "react";

export default function FooterTopLeftSection({data}) {

  return (
    <div className="max-w-96">
      <FlexSection extraClass={"justify-normal items-center gap-1 pb-4"}>
        <Logo />
      </FlexSection>
      <Description text={data?.websiteInfo.title} />
    </div>
  );
}
